(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {
        // Elementos del DOM
        const menuToggle = document.querySelector('.menu-toggle');
        const menuClose = document.querySelector('.menu-close');
        const sideMenu = document.querySelector('.side-menu');
        const mobileMenu = document.querySelector('.mobile-menu');
        const overlay = document.querySelector('.menu-overlay');
        const menuTriggers = document.querySelectorAll('.menu-trigger');
        const submenus = document.querySelectorAll('.submenu');
        const placeholder = document.querySelector('.submenu-placeholder');
        const body = document.body;

        // Verificar que existen los elementos
        if (!menuToggle || !sideMenu || !overlay) {
            console.warn('Elementos del menú no encontrados');
            return;
        }

        /**
         * Activar primer submenú por defecto (MUJER)
         */
        function activateDefaultSubmenu() {
            const firstTrigger = menuTriggers[0]; // Primer elemento (MUJER)
            const firstSubmenu = submenus[0];

            if (firstTrigger && firstSubmenu) {
                firstTrigger.classList.add('active');
                firstSubmenu.classList.add('active');
                if (placeholder) {
                    placeholder.classList.add('hidden');
                }
            }
        }

        /**
         * Abrir menú principal
         */
        function openMenu() {
            sideMenu.classList.add('active');
            mobileMenu.classList.add('active');
            overlay.classList.add('active');
            menuToggle.classList.add('active');
            body.classList.add('menu-open');
            body.style.overflow = 'hidden';

            // Activar MUJER por defecto al abrir
            activateDefaultSubmenu();
        }

        /**
         * Cerrar menú
         */
        function closeMenu() {
            sideMenu.classList.remove('active');
            mobileMenu.classList.remove('active');
            overlay.classList.remove('active');
            menuToggle.classList.remove('active');
            body.classList.remove('menu-open');
            body.style.overflow = '';

            // Resetear submenús
            submenus.forEach(function (submenu) {
                submenu.classList.remove('active');
            });

            menuTriggers.forEach(function (trigger) {
                trigger.classList.remove('active');
            });

            if (placeholder) {
                placeholder.classList.remove('hidden');
            }
        }

        /**
         * Toggle del botón hamburguesa/X
         */
        if (menuToggle) {
            menuToggle.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                // Verificar si el menú está abierto
                const isOpen = sideMenu.classList.contains('active');

                if (isOpen) {
                    closeMenu();
                } else {
                    openMenu();
                }
            });
        }

        /**
         * Botón cerrar (X) dentro del menú lateral
         */
        if (menuClose) {
            menuClose.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                closeMenu();
            });
        }

        /**
         * Click en overlay
         */
        if (overlay) {
            overlay.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                closeMenu();
            });
        }

        /**
         * Mostrar submenú en columna derecha
         */
        menuTriggers.forEach(function (trigger) {
            trigger.addEventListener('click', function () {
                const submenuId = this.getAttribute('data-submenu-id');
                const targetSubmenu = document.getElementById(submenuId);

                // Remover active de todos los triggers y submenús
                menuTriggers.forEach(function (t) {
                    t.classList.remove('active');
                });

                submenus.forEach(function (s) {
                    s.classList.remove('active');
                });

                // Activar el seleccionado
                this.classList.add('active');

                if (targetSubmenu) {
                    targetSubmenu.classList.add('active');
                    if (placeholder) {
                        placeholder.classList.add('hidden');
                    }
                }
            });
        });

        /**
         * Cerrar con tecla ESC
         */
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' || e.key === 'Esc') {
                if (sideMenu.classList.contains('active')) {
                    closeMenu();
                }
            }
        });
    });
})();



const mobileTabs = document.querySelectorAll('.mobile-tab');
const mobilePanels = document.querySelectorAll('.mobile-panel');

mobileTabs.forEach(tab => {
    tab.addEventListener('click', function () {
        const target = this.getAttribute('data-tab');

        mobileTabs.forEach(t => t.classList.remove('active'));
        mobilePanels.forEach(p => p.classList.remove('active'));

        this.classList.add('active');
        document.getElementById(target).classList.add('active');
    });
});

const accordions = document.querySelectorAll('.mobile-accordion');

accordions.forEach(acc => {
    acc.addEventListener('click', function () {
        this.classList.toggle('active');
        const panel = this.nextElementSibling;

        if (panel) {
            panel.style.display =
                panel.style.display === 'block' ? 'none' : 'block';
        }
    });
});

const elements = document.querySelectorAll('.side-menu, .menu-overlay, .mobile-menu');

function checkScroll() {
  if (window.scrollY === 0) {
    elements.forEach(el => el.classList.add('at-top'));
  } else {
    elements.forEach(el => el.classList.remove('at-top'));
  }
}

window.addEventListener('scroll', checkScroll);
checkScroll();